import React from 'react'
import FlexView from 'react-flexview/lib'
import { InsurancePurchaseContextStore } from '../../../../context/InsuracePurchaseContext'
import { AntSwitch } from '../../../Core/Buttons/AntSwitch'
import { ReactComponent as RenewSvg } from '../../../../assets/renew.svg'
import {
  BuyingInsuranceContextStore,
  PlanEnum,
} from '../../../../context/BuyingInsuranceContext'
import { Action } from '../../../../models/Action'
import { Autorenew } from '@material-ui/icons'
import DataLayerService from '../../../../services/DataLayerService'

export const AutoRenewBeforePurchaseSection = ({ location }) => {
  const offersContext = React.useContext(BuyingInsuranceContextStore)
  const [autoRenew, setToggleAutoRenew] = React.useState(
    offersContext.pricebreakdown.autoRenew
  )

  const toggleAutoRenew = () => {
    let newAutoRenewVal = !autoRenew
    setToggleAutoRenew(newAutoRenewVal)

    if (autoRenew) {
      DataLayerService.pushToDataLayer({
        event: 'auto-renew-toggle-turned-off',
      })
    }

    let newCart = { ...offersContext.offerCart }
    newCart['autoRenew'] = newAutoRenewVal
    offersContext.dispatch({
      type: 'CART_CHANGED',
      data: newCart,
    })
  }

  React.useEffect(() => {
    setToggleAutoRenew(offersContext.pricebreakdown.autoRenew)
  }, [offersContext.pricebreakdown.autoRenew])

  return (
    <React.Fragment>
      {location.pathname === '/insurance/credit-card' ? (
        <FlexView
          vAlignContent={'center'}
          className="text-tiny gray margin-top-small">
          <RenewSvg
            className={`small-icon ${autoRenew && 'powderblue-path-svg'}`}
          />
          <div className="margin-left-3">
            Auto-renew is {autoRenew ? 'on' : 'off'}
          </div>
        </FlexView>
      ) : (
        offersContext.offerCart.period.plan !== PlanEnum.Week &&
        offersContext.offerCart.period.plan !== PlanEnum.Day && (
          <FlexView className="text-tiny gray margin-top-small">
            <AntSwitch
              onChange={toggleAutoRenew}
              checked={autoRenew}></AntSwitch>
            <div style={{ 'margin-right': '100px' }}>
              {' '}
              &nbsp; Auto renew is {autoRenew ? 'on' : 'off'}
            </div>
          </FlexView>
        )
      )}
    </React.Fragment>
  )
}
